import {
  Configuration,
  DefaultApi,
  GetFloatSeriesValuesCSVRequest,
} from 'generated/leaderboard-client';

import {
  buildEndpointUrl,
  defaultApiClientConfiguration,
} from '@neptune/shared/core-apis-common-domain';

import { leaderboardHardcodedEndpoints } from './leaderboard-hardcoded-endpoints';

export {
  type EvaluationNonFiniteFloatValue,
  InvalidEvaluationRecordsResponseError,
  type NormalizedEvaluationRecordsResponse,
  type NormalizedEvaluationRecordValue,
  normalizeEvaluationRecordsResponse,
} from './evaluation-records-api';
export type { GroupByKey } from './extended-types/LeaderboardEntryGroupDTO';
// eslint-disable-next-line no-restricted-syntax
export * from 'generated/leaderboard-client/apis';
// eslint-disable-next-line no-restricted-syntax
export * from 'generated/leaderboard-client/models';

export class LeaderboardAPI extends DefaultApi {
  getFloatSeriesCSVDownloadURL(requestParameters: GetFloatSeriesValuesCSVRequest): string {
    return buildEndpointUrl(
      leaderboardHardcodedEndpoints.getFloatSeriesValuesCSV,
      requestParameters,
    );
  }
}

export const leaderboardClient = new LeaderboardAPI(
  new Configuration(defaultApiClientConfiguration),
);
